import { InputProps } from "../../../../../Form/Input";
import { ResponsiveModalInputUI } from "./ui";

const ResponsiveModalInput = ({ ...props }: InputProps) => {
  return <ResponsiveModalInputUI {...props} />;
};

export { ResponsiveModalInput };
